// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"787":"aa489bdd83e6ac4f","6034":"a8125c8801d923da"}[chunkId] + ".js";
};